module.exports = __webpack_public_path__ + "9779d9a1/img/boston-lights.a623432f.png";